import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';
import useBasketContext from '../../../../../contexts/basket/useBasketContext';
import { Item } from '../../../../../contexts/site/site-context';
import { money } from '../../../../../services/format';
import useOperatorContext from "../../../../../contexts/operator/useOperatorContext";

type BasketItemProps = {
    item: Item;
    handleClick: () => void;
    checkout: boolean;
    last?: boolean
};

const BasketItem = ({ item, handleClick, checkout, last }: BasketItemProps) => {
    const basketContext = useBasketContext();
    const operatorContext = useOperatorContext();

    return (
        <Layout border={!last}>
            <Details checkout={checkout} margin={!last}>
                <div className='titlePrice'>
                    <Quantity checkout={checkout} onClick={handleClick}>
                        <div>
                            <span>
                                {item.quantity ?? 1}
                            </span>
                        </div>
                    </Quantity>
                    <div className="b-item-content">
                        <span className="b-item-name" onClick={handleClick}>
                            { item.name }
                        </span>
                        {item.modifiers?.length ? (
                            <div className="b-item-mod flex-column">
                                {item.modifiers?.map((modifier, index) => {

                                   if ( !modifier.display ) return '';

                                    return <span className='p-0 m-0 modifierItem' key={`modifierItem-${index}`}>
                                        { modifier.quantity === -1 ? 'No '+ modifier.name : modifier.name +
                                            ((modifier.quantity ?? 0) > 1 ? ` (${modifier.quantity})` : '') +
                                            (item.modifiers?.length === index + 1 ? '' : ', ')}
                                    </span>

                                })}
                            </div>
                        ) : null}
                    </div>
                    <span className="b-item-price">
                        {money(
                            item.item_total ??
                                item.price * (item.quantity ?? 1) + (item.modifiersTotal ?? 0) * (item.quantity ?? 1),
                            operatorContext.operator?.ccy, operatorContext.operator?.locale
                        )}
                    </span>
                </div>
            </Details>
        </Layout>
    );
};


const Quantity = styled.div<{ checkout?: boolean }>`
    display: flex;
    flex-shrink: 0;
    div {
        span {
            display: block;
            min-width: 24px;
            margin-right: 14px;
            border-radius: var(--radius_m);
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            text-align: center;
        }
    }
`;

const Details = styled.div<{ checkout: boolean, margin: boolean }>`
    max-width: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    ${(props) => (props.margin ? 'margin-bottom: 12px;' : null)}
    > div {
        display: flex;

        &:last-child {
            margin-bottom: 0;
        }
        .b-item-content {
            flex-grow: 1;
        }
        .b-item-name {
            font-size: 16px;
            font-weight: 400;
            display: block;
            width: 100%;
            line-height: 24px;
            ${(props) => (props.checkout ? null : 'cursor: pointer;')}
        }

        .b-item-qty {

            display: block;
            margin-right: 17px;
            margin-left: 6px;
        }

        .b-item-price {
            font-size:  16px;
            padding-left: 12px;
            line-height: 24px;
            font-weight: 400;
            min-width: 74px;
            text-align: right;
        }
        .b-item-remove {
            color: var(--invalid);
            cursor: pointer;
            user-select: none;
            font-size: 13px;
        }
    }

    .b-item-mod {
        font-size: 14px;
        line-height: 20px;
        color: var(--text-black);
    }

    .divider {
        width: 100vw;
        height: 1px;
        background-color: var(--text-grey);
        position: relative;
        left: -16px;
        margin: 24px 0 16px 0;
    }
`;

const Layout = styled.div<{border?: boolean}>`
    padding: 0 0px;
    @media screen and (min-width: 993px) {
        padding: 0;
    }
    display: flex;
    width: 100%;
    .modifierItem {
        color: var(--text-grey);
    }
`;

export default BasketItem;
